export const UTILITIES_ROLES = ['Super Admin', 'Admin', 'Utilities'];

export function hasAnyRole(user, allowedRoles) {
  if (!user || !Array.isArray(user.roles)) {
    return false;
  }

  return user.roles.some((role) => allowedRoles.includes(role));
}

export function canAccessUtilities(user) {
  return hasAnyRole(user, UTILITIES_ROLES);
}
